import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { TrackingType } from 'src/app/model/session-tracking/tracking-type';
import * as TrackingActions from '../session-tracking/tracking.action';

 
export interface State extends EntityState<TrackingType> {
  // additional entities state properties
  selectedTrackId: string | null;
}
 
export const adapter: EntityAdapter<TrackingType> = createEntityAdapter<TrackingType>();
 
export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  selectedTrackId: null,
});
 
export const trackReducer = createReducer(
  initialState,
  on(TrackingActions.addTrackingType, (state, { trackingType }) => {
    return adapter.addOne(trackingType, state)
  }),
  on(TrackingActions.setTrackingType, (state, { trackingType }) => {
    return adapter.setOne(trackingType, state)
  }),
  on(TrackingActions.upsertTrackingType, (state, { trackingType }) => {
    return adapter.upsertOne(trackingType, state);
  }),
  on(TrackingActions.addTrackingTypes, (state, { trackingTypes }) => {
    return adapter.addMany(trackingTypes, state);
  }),
  on(TrackingActions.upsertTrackingTypes, (state, { trackingTypes }) => {
    return adapter.upsertMany(trackingTypes, state);
  }),
  on(TrackingActions.updateTrackingType, (state, { trackingType }) => {
    return adapter.upsertOne(trackingType, state);
  }),
  on(TrackingActions.updateTrackingTypes, (state, { updates }) => {
    return adapter.updateMany(updates, state);
  }),
  on(TrackingActions.mapTrackingType, (state, { entityMap }) => {
    return adapter.mapOne(entityMap, state);
  }),
  on(TrackingActions.mapTrackingTypes, (state, { entityMap }) => {
    return adapter.map(entityMap, state);
  }),
  on(TrackingActions.deleteTrackingType, (state, { id }) => {
    return adapter.removeOne(id, state);
  }),
  on(TrackingActions.deleteTrackingTypes, (state, { ids }) => {
    return adapter.removeMany(ids, state);
  }),
  on(TrackingActions.deleteTrackingTypesByPredicate, (state, { predicate }) => {
    return adapter.removeMany(predicate, state);
  }),
  on(TrackingActions.loadTrackingTypes, (state, { trackingTypes }) => {
    return adapter.setAll(trackingTypes, state);
  }),
  on(TrackingActions.setTrackingTypes, (state, { trackingTypes }) => {
    return adapter.setMany(trackingTypes, state);
  }),
  on(TrackingActions.clearTrackingTypes, state => {
    return adapter.removeAll({ ...state, selectedUserId: null });
  })
);
 
                                                            
export const getSelectedTrackId = (state: State) => state.selectedTrackId;
 
// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
 
// select the array of user ids
export const selectTrackIds = selectIds;
 
// select the dictionary of user entities
export const selectTrackEntities = selectEntities;
 
// select the array of users
export const selectAllTracks = selectAll;
 
// select the total user count
export const selectTrackTotal = selectTotal;